import React, { useMemo, useState } from 'react';
import { TableCell, TableRow, Avatar, Chip, Button } from '@material-ui/core';
import {
  BonusProductTypeText,
  UserBonusProductStatus,
  UserBonusProductStatusText,
  BonusProductType,
  PromoCompatibilityText,
} from '../../data/common';
import moment from 'moment';
import { trim } from 'lodash';
import CardGiftcardRoundedIcon from '@material-ui/icons/CardGiftcardRounded';
import LocationOnRoundedIcon from '@material-ui/icons/LocationOnRounded';
import Swal from 'sweetalert2';
import bonusProductAPI from '../../middleware/bonusProductAPI';
import { alertError } from '../../Util/Util';

const UserBonusProductTableRow = (props) => {
  const { userBonusProduct, onReload } = props;
  const [isRestoring, setIsRestoring] = useState(false);
  const [selected, setSelected] = useState(false);

  const canCancel = useMemo(() => {
    return (
      userBonusProduct.status === UserBonusProductStatus.USED &&
      trim(userBonusProduct.useTime) !== '' &&
      moment(userBonusProduct.useTime).isSame(moment(), 'day')
    );
  }, [userBonusProduct]);

  const handleRestore = () => {
    Swal.fire({
      title: '確定要取消使用嗎？',
      text: userBonusProduct.productInfo.name,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: '確定取消使用',
      cancelButtonText: '返回',
    }).then((result) => {
      if (result.isConfirmed) {
        setIsRestoring(true);
        bonusProductAPI
          .restoreUserProduct(userBonusProduct.id)
          .then(
            () => {
              Swal.fire('完成', '已取消使用', 'success');
              if (onReload) {
                onReload();
              }
            },
            (error) => {
              alertError(error);
            },
          )
          .then(() => {
            setIsRestoring(false);
          });
      }
    });
  };

  const expiry = useMemo(() => {
    const nowDate = moment();
    const expiryDate = moment(userBonusProduct.expiryDate);

    return {
      isExpiry:
        expiryDate.isSameOrBefore(nowDate) &&
        userBonusProduct.status === UserBonusProductStatus.UN_USE,
      expiryDate: expiryDate.format('YYYY-MM-DD'),
    };
  }, [userBonusProduct]);

  return (
    <TableRow selected={selected} onClick={() => setSelected((prev) => !prev)}>
      <TableCell className="user-bonus-product-table__member-cell">
        {userBonusProduct.userInfo.realName}
        <div style={{ fontSize: '10px', color: '#999' }}>
          ID {userBonusProduct.userInfo.id}
        </div>
      </TableCell>

      <TableCell>
        <div className="user__bonus-product__product__name">
          <Avatar
            style={{ marginRight: '12px' }}
            variant="rounded"
            alt="封面"
            src={userBonusProduct.productInfo.mainImage.imageName}
          />
          <div>{userBonusProduct.productInfo.name}</div>
        </div>
      </TableCell>

      <TableCell>
        <Chip
          avatar={
            userBonusProduct.productInfo.storeInfo ? (
              <Avatar src={userBonusProduct.productInfo.storeInfo.imgSrc} />
            ) : (
              <LocationOnRoundedIcon />
            )
          }
          size="small"
          label={
            userBonusProduct.productInfo.storeInfo
              ? userBonusProduct.productInfo.storeInfo.name
              : '不限分店'
          }
        />
      </TableCell>

      <TableCell>
        <Chip
          color={
            userBonusProduct.productInfo.type === BonusProductType.DISCOUNT
              ? 'primary'
              : userBonusProduct.productInfo.type === BonusProductType.EXCHANGE
              ? 'secondary'
              : 'default'
          }
          size="small"
          label={BonusProductTypeText[userBonusProduct.productInfo.type]}
          icon={
            userBonusProduct.isPromo ? <CardGiftcardRoundedIcon /> : undefined
          }
        />
      </TableCell>

      <TableCell>
        {userBonusProduct.productInfo.promoCompatibility !== null &&
        userBonusProduct.productInfo.promoCompatibility !== undefined
          ? PromoCompatibilityText[
              userBonusProduct.productInfo.promoCompatibility
            ]
          : '-'}
      </TableCell>

      <TableCell>
        <div
          style={{
            color:
              !userBonusProduct.productInfo.isNoTimeLimit && expiry.isExpiry
                ? 'red'
                : '',
          }}>
          {userBonusProduct.productInfo.isNoTimeLimit
            ? '無期限'
            : expiry.expiryDate}
        </div>
      </TableCell>

      <TableCell>
        {trim(userBonusProduct.useTime) !== '' &&
          moment(userBonusProduct.useTime).format('YYYY-MM-DD HH:mm:ss')}
      </TableCell>

      <TableCell>
        {userBonusProduct.staffInfo &&
          userBonusProduct.staffInfo !== null &&
          `${userBonusProduct.staffInfo.realName}`}
      </TableCell>

      <TableCell>
        <Chip
          color={
            !userBonusProduct.productInfo.isNoTimeLimit && expiry.isExpiry
              ? 'default'
              : userBonusProduct.status === UserBonusProductStatus.UN_USE
              ? 'primary'
              : 'secondary'
          }
          size="small"
          label={
            !userBonusProduct.productInfo.isNoTimeLimit && expiry.isExpiry
              ? '過期'
              : UserBonusProductStatusText[userBonusProduct.status]
          }
        />
      </TableCell>

      <TableCell>
        {userBonusProduct.giverInfo && userBonusProduct.giverInfo.realName}
      </TableCell>

      <TableCell>{userBonusProduct.referralCode}</TableCell>

      <TableCell>
        {canCancel && (
          <Button
            variant="contained"
            color="secondary"
            size="small"
            disabled={isRestoring}
            onClick={(e) => {
              e.stopPropagation();
              handleRestore();
            }}>
            {isRestoring ? '處理中...' : '取消使用'}
          </Button>
        )}
      </TableCell>
    </TableRow>
  );
};

export default UserBonusProductTableRow;
